import {
  GetterTree, Module, MutationTree, ActionTree,
} from 'vuex'
import { FaqTranslation } from '@/ts/interfaces/wording'
import { cms } from '@/cms'

export interface TranslationState {
  faqLocations: { service: string, page: string }[]
}

const translationState: TranslationState = {
  faqLocations: []
}

const mutations: MutationTree<TranslationState> = {
  SET_TRANSLATION_FAQ_LOCATIONS(state: TranslationState, faqLocations) {
    state.faqLocations = faqLocations
  },
}

const actions: ActionTree<TranslationState, any> = {}

const getters: GetterTree<TranslationState, any> = {
  translationFaqLocations: (state: TranslationState) => state.faqLocations,
  translationFaqs: () => {
    const messagesMap = cms.i18n.translations.find((t) => t.locale.code === cms.i18n.currentLocale.code)?.messages || {}
    const messages: FaqTranslation[] = Object.keys(messagesMap)
      .filter((key) => /faqTitle[0-9]/.test(key))
      .map((key, index) => ({
        title: messagesMap[key],
        text: messagesMap[`faqText${index + 1}`],
        image: messagesMap[`faqImage${index + 1}`],
      }))

    return messages
  }
}

export const translationModule: Module<TranslationState, any> = {
  state: translationState,
  mutations,
  actions,
  getters,
}
